import * as React from 'react';
import { QueryObserverResult } from '@tanstack/react-query';

import {
  Appointment,
  PerDiemReportStatus,
  ReturnAppointmentsDictionary,
  ShiftStatus,
  TriggerPickupAppointmentDict,
} from 'types/Watchlist';

export interface PickupAppointments {
  /** Appointments dictionary where the key is the container number */
  appointments: Record<string, Appointment>;
  status: QueryObserverResult<Appointment>['status'];
  isFetching: boolean;
}

export const ContainerAppointmentsContext = React.createContext<PickupAppointments>({
  appointments: {},
  status: 'loading',
  isFetching: false,
});

export interface PerDiemReportStatuses {
  /** Per diem report status dictionary where the key is the container number */
  reportStatuses: Record<string, PerDiemReportStatus>;
  status: QueryObserverResult<PerDiemReportStatus>['status'];
  refetch?: () => Promise<QueryObserverResult<PerDiemReportStatus[], unknown>>;
}

export const PerDiemReportStatusesContext = React.createContext<PerDiemReportStatuses>({
  reportStatuses: {},
  status: 'loading',
});

export interface ReturnAppointments {
  appointments: ReturnAppointmentsDictionary;
  terminalStatuses: Record<string, ShiftStatus[]>;
  status: QueryObserverResult<unknown>['status'];
}

export const ReturnAppointmentsContext = React.createContext<ReturnAppointments>({
  appointments: {},
  terminalStatuses: {},
  status: 'loading',
});

export interface TriggerPickupAppointments {
  triggerPickupAppointments: TriggerPickupAppointmentDict;
  status: QueryObserverResult<unknown>['status'];
}

export const TriggerPickupAppointmentsContext = React.createContext<TriggerPickupAppointments>({
  triggerPickupAppointments: {},
  status: 'loading',
});
